import React from "react";
import TurnosForm from "admin/turnos/TurnosForm";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Appbar from "./Appbar";

function ReservarTurno() {
  return (
    <>
      <Appbar />
      <Box p={3}>
        <Typography variant="h5">Turno para Moratoria</Typography>
        <Typography variant="h6">Complete el siguiente formulario</Typography>
      </Box>
      <TurnosForm />
    </>
  );
}

export default ReservarTurno;
